import React, { Component } from 'react';
import { Modal, ModalFooter, ModalHeader, ModalBody, Form, FormGroup, Label, Input, Button, Breadcrumb, BreadcrumbItem, Col, Row, Container } from "reactstrap";
import { Link } from "react-router-dom";
import UserPanelMenu from "./../../components/user/UserPanelMenu";
import DayPickerInput from 'react-day-picker/DayPickerInput';
// import AddPasenger from '../../components/passenger/AddPasenger';
// import Pagination from '../../components/passenger/Pagination';
import PassengerItem from '../../components/passenger/PassengerItem';
import axios from 'axios';
import { API_URL, options } from '../../config/Config';
import MUIDataTable from "mui-datatables";




class UserCartsList extends Component {

    constructor(props) {
        super(props);
        this.state = {
            collapse: false,
            fields: {
                type: "1",
                origin: null,
                destination: null,
                departureDate: null,
                origin2: null,
                destination2: null,
                departureDate2: null,
                adult: 1,
                child: 0,
                infant: 0,
                preferences: 0,
            },
            isIran: false,
            modal: false,
            modaldetail: false,
            passengers: [],
            passenger: [],
            columnDefs:
                [
                    {
                        name: "No.",
                        options: {
                            filter: false,
                            sort: false,
                        }
                    },
                    {
                        name: "Name",
                        options: {
                            filter: true,
                            sort: true,
                        }
                    },
                    {
                        name: "Family",
                        options: {
                            filter: true,
                            sort: true,
                        }
                    },
                    {
                        name: "National Id / Passport No",
                        options: {
                            filter: true,
                            sort: true,
                        }
                    },
                    {
                        name: "Details",
                        options: {
                            filter: false,
                            sort: false,
                        }
                    }
                ],
            rowData: [],
        };
        this.toggle = this.toggle.bind(this);
        this.Editpassenger = this.Editpassenger.bind(this);
        this.Editpassengerdetail = this.Editpassengerdetail.bind(this);

    }

    toggle() {
        this.setState({ collapse: !this.state.collapse });
    }


    Editpassenger() {
        this.setState({
            modal: !this.state.modal
        });
    }
    Editpassengerdetail() {
        this.setState({
            modaldetail: !this.state.modaldetail
        });
    }

    async componentDidMount() {
        const access_token = localStorage.getItem('api_token');
        const options = {
            method: 'GET',
            headers: {
                'content-type': 'application/x-www-form-urlencoded',
            },
            url: API_URL + 'passenger?api_token=' + access_token,
        };
        let response = await axios(options);
        console.log(response);
        if (response.status === 200) {
            // this.setState({ passengers: response.data.data.data });
            const rowData = [];
            const passengers = response.data.data.data;
            passengers.map((passenger, i) => {
                if (passenger.country.id === 104) {
                    rowData.push([
                        i + 1, passenger.firstname, passenger.lastname, passenger.national_id, <Button onClick={this.HandelDetail.bind(this, passenger)} >View</Button>
                    ])
                } else {
                    rowData.push([
                        i + 1, passenger.firstname, passenger.lastname, passenger.passport_expired, <Button onClick={this.HandelDetail.bind(this, passenger)} >View</Button>
                    ])
                }
                return true;
            }
            )
            this.setState({ rowData })

        }
    }

    async HandelDetail(e) {
        await this.setState({ passenger: e, modaldetail: !this.state.modal })
    }

    render() {
        const { fields, passenger } = this.state;

        return (
            <div className="pt-5 mt-5">
                <Container>
                    <Breadcrumb className='w-100 white rounded mt-3 rtl'>
                        <BreadcrumbItem><Link to="/">Home</Link></BreadcrumbItem>
                        <BreadcrumbItem><Link to="/users">User Control panel</Link></BreadcrumbItem>
                        <BreadcrumbItem active> Dashboard</BreadcrumbItem>
                    </Breadcrumb>
                    <Row className='mt-3 md-5 rtl'>
                        <Col md='3' sm='12'>
                            <UserPanelMenu activeElement="4" />
                        </Col>
                        <Col md='9' sm='12'>
                            <div className="panel panel-default white">
                                <div className="portlet-title">
                                    <h4 className="user-panel-heading">My Passangers</h4>
                                    <div className="user-panel-content">
                                        {/* <div className="add-passengers">
                                            <Button color="info" onClick={this.toggle} style={{ marginBottom: '1rem' }}>
                                                <i className="fas fa-plus"></i>
                                                Add Passangers</Button>
                                            <Collapse isOpen={this.state.collapse}>
                                                <AddPasenger />
                                            </Collapse>
                                        </div> */}
                                        <div className="passengers-results" >
                                            {/* <Card>
                                                <CardBody>
                                                    <h5 className="inner-passenger-title" > Search passenger</h5>
                                                    <Form>
                                                        <Row className='mt-3 md-5 rtl'>
                                                            <Col md='4' sm='12'>
                                                                <FormGroup>
                                                                    <Label for="searchName">Name</Label>
                                                                    <Input type="text" name="seachname" id="searchName" placeholder="Type Passenger Name" />
                                                                </FormGroup>
                                                            </Col>
                                                            <Col md='4' sm='12'>
                                                                <FormGroup>
                                                                    <Label for="searchfamily">Family</Label>
                                                                    <Input type="text" name="seachfamily" id="searchfamily" placeholder="Type Passenger family" />
                                                                </FormGroup>
                                                            </Col>
                                                            <Col md='4' sm='12'>
                                                                <FormGroup>
                                                                    <Label for="search-national-code">National Code / Passport No</Label>
                                                                    <Input type="number" name="search-National-Code" id="Search-National-Code" placeholder="Type Number" />
                                                                </FormGroup>
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col md='12' sm='12'>
                                                                <Button color="danger" type="submit" style={{ marginBottom: '1rem' }}><i className="fas fa-search"></i>Search</Button>
                                                            </Col>
                                                        </Row>
                                                    </Form>

                                                </CardBody>
                                            </Card> */}
                                            {/* <div className="pageinitation">
                                                <Pagination />
                                            </div> */}
                                            <MUIDataTable
                                                data={this.state.rowData}
                                                columns={this.state.columnDefs}
                                                options={options}
                                            />

                                        </div>

                                    </div>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
                <Modal isOpen={this.state.modaldetail} toggle={this.Editpassengerdetail} className=" edit-modal">
                    <ModalHeader toggle={this.Editpassengerdetail}>View Passenger Details</ModalHeader>
                    <ModalBody>
                        <PassengerItem
                            passenger={passenger}
                        />
                    </ModalBody>

                </Modal>

                <Modal isOpen={this.state.modal} toggle={this.Editpassenger} className=" edit-modal">
                    <ModalHeader toggle={this.Editpassenger}>Edit Passenger</ModalHeader>
                    <ModalBody>
                        <Form>
                            <Row className='mt-3 md-5 rtl'>
                                <Col md='2' sm='12'>
                                    <FormGroup>
                                        <Label for="exampleGender">Gender</Label>
                                        <Input type="select" name="gender" id="exampleGender">
                                            <option>Male</option>
                                            <option>Female</option>
                                        </Input>
                                    </FormGroup>
                                </Col>
                                <Col md='5' sm='12'>
                                    <FormGroup>
                                        <Label for="Name">Name</Label>
                                        <Input type="text" name="name" id="exampleName" placeholder="Type Passenger Name" />
                                    </FormGroup>
                                </Col>
                                <Col md='5' sm='12'>
                                    <FormGroup>
                                        <Label for="Family">Family</Label>
                                        <Input type="text" name="family" id="exampleFamily" placeholder="Type Passenger Family" />
                                    </FormGroup>
                                </Col>
                            </Row>
                            {this.state.isIran === false ?
                                <Row className='mt-3 md-5 rtl'>
                                    <Col md='3' sm='12'>
                                        <FormGroup>
                                            <Label for="exampleCountry">Country</Label>
                                            <Input type="select" name="select" id="exampleCountry" onChange={this.handelCountry} >
                                                <option>canada</option>
                                                <option >iran</option>
                                                <option>usa</option>
                                                <option>uae</option>
                                                <option>uk</option>
                                            </Input>
                                        </FormGroup>
                                    </Col>


                                    <Col md='3' sm='12'>
                                        <FormGroup>
                                            <Label for="Name">Passport No</Label>
                                            <Input type="number" name="Passport-No" id="examplePassport-No" placeholder="Type Passenger Passport Number" />
                                        </FormGroup>
                                    </Col>
                                    <Col md='3' sm='12'>
                                        <FormGroup>
                                            <Label for="Family">Brith Date</Label>
                                            <DayPickerInput
                                                placeholder="Brith Date"
                                                selectedDays={fields.departureDate}
                                                onDayChange={this.handleDayChange}
                                            // dayPickerProps={{renderDay:this.renderDay}}
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col md='3' sm='12'>
                                        <FormGroup>
                                            <Label for="Family">Passport Expire</Label>
                                            <DayPickerInput
                                                placeholder="Passport Expire"
                                                selectedDays={fields.departureDate}
                                                onDayChange={this.handleDayChange}
                                            // dayPickerProps={{renderDay:this.renderDay}}
                                            />
                                        </FormGroup>
                                    </Col>
                                </Row>
                                :
                                <Row className='mt-3 md-5 rtl'>
                                    <Col md='3' sm='12'>
                                        <FormGroup>
                                            <Label for="exampleCountry">Country</Label>
                                            <Input type="select" name="select" id="exampleCountry" onChange={this.handelCountry} >
                                                <option>canada</option>
                                                <option >iran</option>
                                                <option>usa</option>
                                                <option>uae</option>
                                                <option>uk</option>
                                            </Input>
                                        </FormGroup>
                                    </Col>
                                    <Col md='6' sm='12'>
                                        <FormGroup>
                                            <Label for="Name">National Code</Label>
                                            <Input type="number" name="National-Code" id="exampleNational-Code" placeholder="Type Passenger National Code" />
                                        </FormGroup>
                                    </Col>
                                </Row>
                            }

                        </Form>
                    </ModalBody>
                    <ModalFooter>
                        <Button color="info" >Submit</Button>{' '}
                        <Button color="error" >Cancel</Button>
                    </ModalFooter>
                </Modal>
            </div>
        );
    }
}
// const mapStateToProps = (api_token) => {
//     return {
//         api_token: api_token,
//     }
// };
// export default connect(mapStateToProps, null)(UserCartsList)
export default UserCartsList;


// WEBPACK FOOTER //
// ./src/containers/user/UserCartsList.jsx